import {
    apiRequest,
    penataranList,
    penataranInactive,
    penataranActive,
    penataranDetail
} from "../../../../../services/adapters/kepegawaian/penataranService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", penataranList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", penataranInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", penataranActive, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", penataranDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

}

export default DataTableRepository